import { Component, OnInit, Input } from '@angular/core';
import { BookingBreadcrumbsService } from '../../services/booking-breadcrumbs.service';
import { IBreadcrumbsService } from '../../../general/interfaces/breadcrumbs-service.interface';
import { NotificationService } from 'src/app/modules/general/services/notification.service';

@Component({
  selector: 'app-booking-page',
  templateUrl: './booking.page.html',
  styleUrls: ['./booking.page.css']
})
export class BookingPageComponent implements OnInit {

  constructor(
    private bookingBreadcrumbsService: BookingBreadcrumbsService,
    private notificationService: NotificationService,
  ) {
  }

  ngOnInit() {
  }

  get hasActiveBreadcrumbs() {
    return this.bookingBreadcrumbsService.hasActiveBreadcrumbs;
  }

  get breadcrumbsService(): IBreadcrumbsService {
    return this.bookingBreadcrumbsService;
  }

  get isAllowedShowHeader(): boolean {
    return !this.notificationService?.messages?.length;
  }
}
